import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_IOPorts = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="I/O Ports"
      videos={[
        "https://www.youtube.com/embed/m3riF4rY8Hg", // I/O Ports of 8051 Microcontroller
      ]}
      takeaways={[
        { text: "Expect logic-based programming questions, such as calculating area, perimeter, or solving expressions." },
        { text: "In questions, input and output ports may be mentioned directly or inferred by reading carefully." },
        { text: "Always move FFH to the input port through the accumulator to indicate it as an input port." },
        { text: "Learn how to use JB, JNB, SETB, and CLR commands in port programming." },
        { text: "A single bit cannot be moved directly from one port to another. Use carry: MOV C, P2.7 | MOV P1.0, C." },
        { text: "Byte data can be moved directly between ports: MOV P2, P1 is correct." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_IOPorts;
